import { Grid, TypographyProps } from "@mui/material";
import MxTypography from "../MxTypography";

interface MxAlertTitleEventProps {
  children: React.ReactNode;
  color?: TypographyProps["color"];
}
function MxAlertTitleEvent(props: MxAlertTitleEventProps) {
  const { children, color = "primary" } = props;
  return (
    <Grid container item xs={12}>
      <Grid item xs={12}>
        <MxTypography variant="h6"  color={color}>
          {children}
        </MxTypography>
      </Grid>
    </Grid>
  );
}

export default MxAlertTitleEvent;
